(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.getElementById('animated-hero-{{ section.id }}');
    if (section && window.AnimatedHero) {
      window.AnimatedHero.init(section);
    }
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === '{{ section.id }}' && window.AnimatedHero) {
        const section = document.getElementById('animated-hero-{{ section.id }}');
        window.AnimatedHero.init(section);
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      if (event.detail.sectionId === '{{ section.id }}') {
        const section = document.getElementById('animated-hero-{{ section.id }}');
        const blocks = section.querySelectorAll('.animated-hero__text-block');
        blocks.forEach(block => {
          block.style.opacity = block.dataset.blockId === event.detail.blockId ? '1' : '0';
          block.style.visibility = block.dataset.blockId === event.detail.blockId ? 'visible' : 'hidden';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-backup"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
